import { FC, useMemo } from 'react';
import classNames from 'classnames';

import CollapsibleList from '../CollapsibleList';
import CollapsibleListItem from '../CollapsibleList/CollapsibleListItem';

import styles from './SelfIntroduction.module.scss';

const NEW_LINE_REGEX = /\n{3,}/g;
const SPACE_REGEX = / {3,}/g;

const formatContent = (value: string) =>
  value.replace(NEW_LINE_REGEX, '\n\n').replace(SPACE_REGEX, '  ');

const TRANSLATIONS = {
  en: {
    otherIntro: 'Other',
  },
  ja: {
    otherIntro: 'その他特長などの紹介',
  },
};

interface QuestionAndAnswer {
  answer: string;
  question: string;
}

interface Props {
  background?: boolean;
  content?: string;
  filteredQuestionAnswers: Array<QuestionAndAnswer>;
  isDashboardView?: boolean;
  language: 'en' | 'ja';
  title?: string;
  proMatchingCriteria?: React.ReactNode;
}

export const SelfIntroduction: FC<Props> = ({
  background = false,
  content = '',
  filteredQuestionAnswers,
  isDashboardView = false,
  language,
  title = '',
  proMatchingCriteria = <></>,
}) => {
  const questionAndAnswersListItems = useMemo(
    () =>
      filteredQuestionAnswers.map(({ answer, question }) => ({
        content: answer,
        title: question,
      })),
    [filteredQuestionAnswers]
  );

  const otherIntro = (
    <>
      <p className={styles['z-self-introduction-content']}>{formatContent(content)}</p>
      {proMatchingCriteria}
    </>
  );

  return (
    <div
      className={classNames(styles['z-self-introduction'], {
        [styles['z-self-introduction-background']]: background,
      })}
    >
      <div
        className={classNames(styles['z-self-introduction-title'], {
          [styles['small-title']]: isDashboardView,
        })}
      >
        {title}
      </div>
      {filteredQuestionAnswers.length > 0 && (
        <div className={styles['question-answers-section']}>
          <CollapsibleList
            listItems={questionAndAnswersListItems}
            listItemsHeaderVariant="h5"
            isExpanded={false}
          />
        </div>
      )}
      {Boolean(content) && (
        <CollapsibleListItem
          key={TRANSLATIONS[language].otherIntro}
          content={otherIntro}
          isExpanded={false}
          title={TRANSLATIONS[language].otherIntro}
          headerVariant="h5"
        />
      )}
    </div>
  );
};
export default SelfIntroduction;
export type { Props as SelfIntroductionProps };
